export type AdvancedRuleColorOption = {
  value: string;
  label: string;
  description?: string;
};

export const ADVANCED_RULE_COLOR_OPTIONS: AdvancedRuleColorOption[] = [
  { value: 'rgb(59 130 246)', label: 'Blue', description: 'Default map accent' },
  { value: 'rgb(14 165 233)', label: 'Sky', description: 'Cool and bright' },
  { value: 'rgb(6 182 212)', label: 'Cyan', description: 'Water and utilities' },
  { value: 'rgb(20 184 166)', label: 'Teal', description: 'Calm and distinct' },
  { value: 'rgb(34 197 94)', label: 'Green', description: 'Healthy or available' },
  { value: 'rgb(132 204 22)', label: 'Lime', description: 'Fresh and active' },
  { value: 'rgb(245 158 11)', label: 'Amber', description: 'Warning or pending' },
  { value: 'rgb(249 115 22)', label: 'Orange', description: 'Construction or work in progress' },
  { value: 'rgb(239 68 68)', label: 'Red', description: 'Blocked or critical' },
  { value: 'rgb(244 63 94)', label: 'Rose', description: 'Attention grabber' },
  { value: 'rgb(168 85 247)', label: 'Purple', description: 'Rare or special cases' },
  { value: 'rgb(100 116 139)', label: 'Slate', description: 'Neutral baseline' },
  { value: 'rgb(148 163 184)', label: 'Cloud', description: 'Fallback and secondary' },
];

export const DEFAULT_ADVANCED_RULE_COLOR = ADVANCED_RULE_COLOR_OPTIONS[0]?.value ?? 'rgb(59 130 246)';

const LEGACY_ADVANCED_RULE_COLOR_MAP: Record<string, string> = {
  'var(--primary)': 'rgb(59 130 246)',
  'var(--accent)': 'rgb(249 115 22)',
  'var(--muted-foreground)': 'rgb(100 116 139)',
  'var(--destructive)': 'rgb(239 68 68)',
  'var(--foreground)': 'rgb(100 116 139)',
  'var(--card-foreground)': 'rgb(148 163 184)',
};

export const normalizeAdvancedRuleColor = (value?: string | null): string => {
  const trimmed = value?.trim() ?? '';
  if (!trimmed) {
    return DEFAULT_ADVANCED_RULE_COLOR;
  }
  if (LEGACY_ADVANCED_RULE_COLOR_MAP[trimmed]) {
    return LEGACY_ADVANCED_RULE_COLOR_MAP[trimmed];
  }
  if (trimmed.startsWith('var(')) {
    return DEFAULT_ADVANCED_RULE_COLOR;
  }
  return trimmed;
};
